// extracted by mini-css-extract-plugin
module.exports = {"answer-container":"styles__answer-container___fbOeK","label":"styles__label___DM4pG","post-content":"styles__post-content___1i8wW"};